<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase showcase-title="Injury Classification Management">
  <div class="showcase-body">
    <div class="margin: auto; max-width: 1000px; margin-bottom: 50px;margin-top: 20px;">
      <span class="section-header">Add New</span>
      <div class="row">
        <div class="col-lg-2 col-md-8 col-sm-8 col-xs-8 group">
          <input id="newClass" #newClass class="modelo-text-input" type="text" maxlength="50" (blur)="onBlur($event)">
          <label for="newClass">Classification:</label>
        </div>
        <div class="col-lg-4 col-md-4 col-sml-4 col-xs-4 group">
          <input id="newDesc" #newDesc class="modelo-text-input" type="text" maxlength="200" (blur)="onBlur($event)">
          <label for="newDesc">Description:</label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group">
          <button id="addNew" class="btn-xs btn-primary btn-group" (click)="addNew(newClass.value, newDesc.value)"><i
            class="fa fa-save"></i>&nbsp;Submit
          </button>
        </div>
      </div>
      <div>&nbsp;</div>
      <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
        <table class="bordered-table highlight-table ">
          <thead class="data-table-header">
          <tr>
            <th>Classification</th>
            <th>Description</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let dl of injuryClassifications; let index = index; " class="data-table-row">
            <td>
              <input name="{{'class__'+ dl.injuryClassificationId}}" class="modelo-text-input" type="text" [(ngModel)]="dl.injuryClassification" maxlength="50" required #class="ngModel">
              <small *ngIf="class.errors && class.errors.required" class="validationError">Required</small>
            </td>
            <td>
              <input name="{{'description__'+ dl.injuryClassificationId}}" class="modelo-text-input" type="text" [(ngModel)]="dl.description" maxlength="200" required #description="ngModel">
              <small *ngIf="description.errors && description.errors.required" class="validationError">Required</small>
            </td>
          </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" (click)="f.ngSubmit.emit()" [disabled]="!f.form.valid"><i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
  <button id="ResetChange" #ResetChange class="btn btn-primary-white btn-group" onclick="window.location.reload()">
    <i class="fa fa-refresh"></i>&nbsp;Reset</button>&nbsp;
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
</div>

